import {
	defAction
}from "../../../../helpers/defaultAction"
import downloadFile from "../../../../helpers/downloadFile"
import api from './api'
import {
	reConstructionMaterialConstants
}from "./constants"

export const reConstructionMaterialActions = {
	getList,
	clear,
	getHierarchy,
	getPaged,
	getPagedAll,
	getPagedAudit,
	getMaterialOrgPriceInfoPaged,
	createMaterial,
	deleteMaterial,
	updateMaterial,
	restoreMaterial,
	getCharacteristicsFile,
	getExampleFile,
	updateClassifier
}

function getList(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function createMaterial(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateMaterial(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteMaterial(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreMaterial(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getMaterialOrgPriceInfoPaged(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.getMaterialOrgPriceInfoPaged,
		service   : {
			func   : api.getMaterialOrgPriceInfoPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getHierarchy(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.getHierarchy,
		service   : {
			func   : api.getHierarchy,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.getPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.getPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAudit(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.getPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getCharacteristicsFile(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.GetCharacteristicsFile,
		service   : {
			func   : api.getCharacteristicsFile,
			params : values
		},
		sucFunction: (res) => downloadFile(res, "Характеристики строительных материалов.xlsx")
	}
	return defAction(dispatchObj)
}

function getExampleFile(){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.getExampleClassifierFile,
		service   : {
			func: api.getExampleFile
		},
		sucFunction: (res) => downloadFile(res, "Шаблон классификатора.xlsx")
	}
	return defAction(dispatchObj)
}

function updateClassifier(values){
	const dispatchObj = {
		constants : reConstructionMaterialConstants.updateClassifier,
		service   : {
			func   : api.updateClassifier,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reConstructionMaterialConstants.CLEAR
	})
}